<template>
    <v-dialog  persistent  v-model="dialog" :width="(actionMode == 'info') ? `50%` : `70%`" >      
        
      <v-card>
        <v-card-title class="blue white--text" v-if="actionMode == 'execute'">Actie uitvoeren</v-card-title>
        <v-card-title class="red white--text" v-if="actionMode == 'cancel'">Actie annuleren</v-card-title>
        <v-card-title class="blue white--text" v-if="actionMode == 'info'">Actie informatie</v-card-title>
        <v-divider></v-divider>
        <v-card-text >
            <v-layout  class="layout grey lighten-4 px-2 py-2" wrap row>
                <v-flex xs6 lg6  >
                    <div class="dd-label">Assetnaam</div>
                    <div class="dd-value">{{asset.name}}</div>
                </v-flex>
                <v-flex xs6 lg6>
                    <div class="dd-label">Type</div>
                    <div class="dd-value">{{asset.type.name}}</div>
                </v-flex>
                <v-flex xs6 lg6>
                    <div class="dd-label">Groep</div>
                    <div class="dd-value">{{asset.group.name}}</div>
                </v-flex>
                <v-flex xs6 lg6>
                    <div class="dd-label">Locatie</div>
                    <div class="dd-value">{{((asset.street) ? asset.street : "Onbekende straat")}}, {{asset.city}}</div>
                </v-flex>                
            </v-layout>
            <v-layout  class="layout px-2 py-2"  column>
                <v-flex>
                    <v-stepper value="2" flat light class="dd-flat" v-if="actionMode != 'info'">
                        <v-stepper-header>
                        <v-stepper-step step="1" complete color="success" complete-icon="notification_important">{{action.processedEvent.unitTypeEvent.name}}</v-stepper-step>

                        <v-divider></v-divider>

                        <v-stepper-step step="2">{{action.eventAction.name}}</v-stepper-step>

                        <v-divider></v-divider>

                        <v-stepper-step step="3"  color="accent" complete complete-icon="notification_important">{{action.eventAction.doneEvent.name}}</v-stepper-step>
                        </v-stepper-header>
                    </v-stepper>
                    <v-stepper value="2" flat light class="dd-flat" v-else>
                        <v-stepper-header>
                        <v-stepper-step step="1" complete color="success" complete-icon="notification_important">{{action.processedEvent.unitTypeEvent.name}}</v-stepper-step>

                        <v-divider></v-divider>

                        <v-stepper-step step="2" complete color="success">{{action.eventAction.name}}</v-stepper-step>

                        <v-divider></v-divider>

                        <v-stepper-step step="3"  color="success" complete complete-icon="notification_important">{{action.eventAction.doneEvent.name}}</v-stepper-step>
                        </v-stepper-header>
                    </v-stepper>
                </v-flex>
                <v-flex v-if="actionMode == 'info'">
                    <b>Opmerkingen:</b><br>
                    {{action.comments}}
                </v-flex>
                <v-flex v-else>
                    <v-textarea
                        outline
                        name="input-7-4"
                        label="Opmerkingen"
                        value=""
                        v-model="comments"
                        ></v-textarea>
                </v-flex>
                <!-- <v-flex py-2><b>Reden:</b> {{action.processedEvent.assetUnitTypeEvent.name}}</v-flex>
                <v-flex py-2><b>Actie:</b> {{action.eventAction.name}}</v-flex> -->                                
            </v-layout>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="red darken-1" flat @click="$emit('closeClicked')" v-if="actionMode == 'cancel'">Sluiten</v-btn>
          <v-btn color="blue darken-1" flat @click="$emit('closeClicked')" v-else>Sluiten</v-btn>
          <v-spacer></v-spacer>          
          <v-btn color="red darken-1" flat @click="cancelAction()"   v-if="actionMode == 'cancel'">Actie annuleren</v-btn>
          <v-btn color="blue darken-1" flat @click="executeAction()" v-if="actionMode == 'execute'">Actie uitvoeren</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>

import { mapGetters } from 'vuex'
import * as types from "../../store/types"

export default{    
    props:['action', 'asset', 'mode'],
    data(){
        return {
            dialog: true,
            comments: ''
        }
    },
    computed:{
        actionMode(){
            if(this.mode == null){                
                return "execute"
            }
            return this.mode
        }
    },
    methods:{
        executeAction(){
            this.$store.dispatch(types.ASSET_EXECUTE_ACTION, { data: {...this.action, comments: this.comments }}).then(() => {
                this.$notify("Actie uitgevoerd", {type: 'success', icon: 'check'})
                this.$emit('actionExecuted')
            }).catch((e) => {
                console.error(e)
            })
            
        },
        cancelAction(){
            this.$store.dispatch(types.ASSET_CANCEL_ACTION, { data: {...this.action, comments: this.comments }}).then(() => {
                this.$notify("Actie uitgevoerd", {type: 'success', icon: 'check'})
                this.$emit('actionCancelled')
            }).catch((e) => {
                console.error(e)
            })
            
        }
    },
    mounted(){
    }
}
</script>